import { classNames } from '@discngine/moosa-common';
import React, { FC, useCallback } from 'react';

import { useComponentsContext } from '../../ComponentsContext/ComponentsContext';
import { ColorPickerPanelPure } from '../ColorPickerPanelPure/ColorPickerPanelPure';
import { ColorView } from '../ColorView/ColorView';
import { ColorViewStub } from '../ColorViewStub/ColorViewStub';

import styles from './ColorPickerPure.module.less';

export type ColorPickerPureProps = {
  color?: string;
  onColorChange?: (color: string) => void;
  isDisabled?: boolean;
};

export const ColorPickerPureGeneric: FC<ColorPickerPureProps> = React.memo(
  function ColorPickerPure({ color, onColorChange, isDisabled }) {
    const { Dropdown } = useComponentsContext();

    const picker = useCallback(
      () => (
        <div className={styles.colorPanel}>
          <ColorPickerPanelPure color={color} onColorChange={onColorChange} />
        </div>
      ),
      [color, onColorChange]
    );

    return (
      <Dropdown disabled={isDisabled} dropdownRender={picker} trigger={['click']}>
        <div
          className={classNames(styles.colorView, {
            [styles.active]: !!color,
          })}
        >
          {color && <ColorView color={color} />}
          {!color && <ColorViewStub />}
        </div>
      </Dropdown>
    );
  }
);
